import UpdateEncryptionSettingsDrawer from "./UpdateEncryptionSettings";

const securityDrawersComponents = {
  UpdateEncryptionSettingsDrawer
}

export default securityDrawersComponents;